export function isNever(value: never): never {
  throw new Error(`This function should never be executed, but found this value: ${value}`);
}
